import { render, staticRenderFns } from "./CalendarBasic.vue?vue&type=template&id=897966e8&"
import script from "./CalendarBasic.vue?vue&type=script&lang=js&"
export * from "./CalendarBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports